module.exports = __webpack_public_path__ + "static/media/fbImg.18ddd76f.svg";